import { useState } from 'react';
import type { Faq } from '@/i18n';

/**
 * Accordéon partagé par la landing (top 10) et la page `/faq` (les 40, groupe
 * par groupe). `idPrefix` garde les `id` uniques quand plusieurs listes vivent
 * sur la même page.
 */
export function FaqList({ items, idPrefix, openFirst }: { items: Faq[]; idPrefix: string; openFirst: boolean }) {
  const [open, setOpen] = useState<number | null>(openFirst ? 0 : null);

  return (
    <div className="nz-faq__grid">
      {items.map((faq, index) => {
        const isOpen = open === index;
        const panelId = `${idPrefix}-panel-${index}`;
        const buttonId = `${idPrefix}-button-${index}`;

        return (
          <div className="nz-faq__item" key={faq.q}>
            <button
              type="button"
              id={buttonId}
              className="nz-faq__q"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => setOpen(isOpen ? null : index)}
            >
              <span>{faq.q}</span>
              {/* Le « + » pivote de 45° et devient une croix quand la réponse est ouverte.
                  La rotation est câblée sur `aria-expanded` en CSS : un seul état, pas deux. */}
              <span className="nz-faq__sign" aria-hidden="true">
                +
              </span>
            </button>
            {isOpen ? (
              <div className="nz-faq__a" id={panelId} role="region" aria-labelledby={buttonId}>
                {faq.a}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
